const Divider = () => {
  return (
    <div className="divider">
      <div className="hexagon">
        <div className="hexagon-inner">
          <div className="hexagon-inner-2"></div>
        </div>
      </div>
      <div className="hexagon middle">
        <div className="hexagon-inner">
          <div className="hexagon-inner-2"></div>
        </div>
      </div>
      <div className="hexagon">
        <div className="hexagon-inner">
          <div className="hexagon-inner-2"></div>
        </div>
      </div>
    </div>
  );
};

export default Divider;
